import styled from 'styled-components';

import { Text } from '../../../../components';
import { COLORS, SPACE } from '../../../../theme/tokens';

/** The bar above the Site defaults panels: the Generate button and, when nothing is empty, why it is off. */
export const Bar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACE[12]};
`;

export const Hint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const Languages = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
`;

export const RowHead = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${SPACE[8]};
`;

/** A row's detail lines, indented under the label (the checkbox's 18px box plus its 10px gap). */
export const Note = styled(Text)`
  padding-left: ${SPACE[28]};
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACE[8]};
`;
